import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { DeveloperRanking } from '../models/developerRanking';

@Component({
  template: ` <a
    class="d-flex flex-nowrap justify-content-start align-items-center"
  >
    <img
      src="{{ data?.topAppIcon }}"
      alt="{{ developerName }} Icon"
      onerror="this.src='/assets/icons/icon-72x72-grey.png'"
      class="mr-2 rounded d-inline"
      width="32"
    />
    <div>
      <div class="d-flex align-items-center">
        <span class="developer-name">{{ developerName }}</span>
        <img
          src="https://cdn.pixalate.com/icons/countries/flat/48/{{
            countryCode
          }}.png"
          alt="{{ countryCode }} Icon"
          onerror="this.src='/assets/icons/icon-flag.png'"
          class="mx-2 rounded"
          width="24"
          [attr.title]="countryName"
          enTooltip
        />
      </div>
      <div class="reach-subtitle" *ngIf="consumerReach">
        <i class="fa fa-users"></i> {{ consumerReach }}
      </div>
    </div>
  </a>`,
  styles: [
    `
      .developer-name {
        font-weight: 600;
        color: #2d3748;
      }
      .reach-subtitle {
        font-size: 13px;
        color: #2652b2;
        margin-top: 4px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 4px;
      }
      .reach-subtitle .fa-users {
        font-size: 12px;
        opacity: 0.8;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeveloperNameComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input() data: DeveloperRanking;

  developerName;
  countryCode;
  countryName;
  consumerReach;

  ngOnInit(): void {
    super.ngOnInit();
    this.developerName = this.data?.developerName;
    this.countryCode = this.data.developerCountryCode;
    this.countryName = this.data?.developerCountryName;
    this.consumerReach = this.data?.estimatedConsumerReachRange;

    if (this.countryName == 'Unknown') {
      this.countryName = 'COUNTRY UNKNOWN';
    }
  }
}
